var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRedirectButtonIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9688 8.625H10.1562C9.93187 8.625 9.75 8.80687 9.75 9.03125V11.875H1.625V3.75H5.28125C5.50563 3.75 5.6875 3.56813 5.6875 3.34375V2.53125C5.6875 2.30687 5.50563 2.125 5.28125 2.125H1.21875C0.545645 2.125 0 2.67064 0 3.34375V12.2812C0 12.9544 0.545645 13.5 1.21875 13.5H10.1562C10.8294 13.5 11.375 12.9544 11.375 12.2812V9.03125C11.375 8.80687 11.1931 8.625 10.9688 8.625ZM12.3906 0.5H9.14062C8.59803 0.5 8.32686 1.15787 8.70898 1.54102L9.61619 2.44822L3.42773 8.63439C3.18934 8.87195 3.18868 9.25778 3.42624 9.49618L3.42773 9.49767L4.00334 10.0723C4.24089 10.3107 4.62673 10.3113 4.86512 10.0738L4.86662 10.0723L11.052 3.88508L11.959 4.79102C12.3398 5.17188 13 4.90527 13 4.35938V1.10938C13 0.772822 12.7272 0.5 12.3906 0.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedirectButtonIcon);
export default __webpack_public_path__ + "static/media/redirect_button_icon.7a28d45a.svg";
export { ForwardRef as ReactComponent };